import { ActionDropdown } from '@ctw/shared/components/dropdown/action-dropdown';
import type { FilterOptionSelect } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface PromotedFilterDropdownProps {
  id?: string;
  testId?: string;
  className?: ClassName;
  filter: FilterOptionSelect;
  selectedValue: string;
  onChange: (valueKey: string) => void;
}

const valueKey = (value: FilterOptionSelect['values'][number]) =>
  typeof value === 'string' ? value : value.key;
const valueName = (value: FilterOptionSelect['values'][number]) =>
  typeof value === 'string' ? value : value.name;

export const PromotedFilterDropdown = ({
  id,
  testId,
  className,
  filter,
  selectedValue,
  onChange,
}: PromotedFilterDropdownProps) => {
  const label = typeof filter.display === 'string' ? filter.display : filter.key;
  const selectedName =
    filter.values
      .map((value) => ({ key: valueKey(value), name: valueName(value) }))
      .find((value) => value.key === selectedValue)?.name ?? selectedValue;

  return (
    <ActionDropdown
      className={tw`z-[600] max-h-[17.25rem] overflow-y-auto`}
      type="select"
      buttonClassName={twx(
        className,
        'w-min rounded-md border border-divider-main bg-transparent p-0 shadow-sm',
      )}
      onItemSelect={(item) => onChange(item.key)}
      items={filter.values.map((value) => ({
        key: valueKey(value),
        name: valueName(value),
        isSelected: valueKey(value) === selectedValue,
      }))}
    >
      <div
        id={id}
        data-testid={testId}
        className={tw`flex items-center space-x-2 rounded-md border border-border-main border-solid bg-white px-3 py-1 font-medium text-content-subtle text-sm capitalize shadow-sm hover:bg-background-hover`}
      >
        <span className={tw`whitespace-nowrap`}>
          {label}: <span className={tw`font-normal`}>{selectedName}</span>
        </span>
        <FontAwesomeIcon icon={faChevronDown} className={tw`ml-auto w-2`} />
      </div>
    </ActionDropdown>
  );
};
